import React from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../components/auth/auth.selector";
import DFPayments from "../../components/deffered-payments/DFPayments";

const DefferedPayments = () => {
  const userInfoData = useSelector(selectUser);

  return <DFPayments userInfoData={userInfoData} />;
};

export default DefferedPayments;
